import { configureStore } from '@reduxjs/toolkit'
import { rootReducer } from './reducer'
import { authApi } from '../api/authApi'
import { usersApi } from '../api/userApi'
import { employeesApi } from '../api/employeesApi'
import { projectsApi } from '../api/projectsApi'
import { projectManagersApi } from '../api/projectManagersApi'
import { projectEmployeeLinksApi } from '../api/projectEmployeeLinksApi'
import { sequenceProjectApi } from '../api/sequenceProjectApi'

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
      .concat(authApi.middleware)
      .concat(usersApi.middleware)
      .concat(employeesApi.middleware)
      .concat(projectsApi.middleware)
      .concat(projectManagersApi.middleware)
      .concat(projectEmployeeLinksApi.middleware)
      .concat(sequenceProjectApi.middleware)
})

export type RootState = ReturnType<typeof store.getState>
